import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";
import "./Header.css";
export default function Header() {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const handleLogin = () => {
        instance.loginPopup(loginRequest);
    };
    const handleLogout = () => {
        instance.logoutPopup();
    };
    return (_jsxs("header", { className: "header", children: [_jsx("h1", { children: "Warehouse Notifications" }), isAuthenticated ? (_jsx("button", { onClick: handleLogout, children: "Sign Out" })) : (_jsx("button", { onClick: handleLogin, children: "Sign In" }))] }));
}
